export default class Masonry {
    constructor(element) {
        this.root = element;

        //sm
        this.smColumns = parseInt(this.root.getAttribute("data-sm-columns")) || 1;
        this.smBreakpoint = parseInt(this.root.getAttribute("data-sm-breakpoint")) || 576;

        //md
        this.mdColumns = parseInt(this.root.getAttribute("data-md-columns")) || 1;
        this.mdBreakpoint = parseInt(this.root.getAttribute("data-md-breakpoint")) || 768;

        //lg
        this.lgColumns = parseInt(this.root.getAttribute("data-lg-columns")) || 2;
        this.lgBreakpoint = parseInt(this.root.getAttribute("data-lg-breakpoint")) || 992;

        this.xlColumns = parseInt(this.root.getAttribute("data-xl-columns")) || 2;
        this.xlBreakpoint = parseInt(this.root.getAttribute("data-xl-breakpoint")) || 1200;

        //columns
        this.columns = this.root.querySelectorAll('.masonry-column')

        this.cells = []
        this.columnAmount = 0

        this.sortCellsInColumns()

        window.addEventListener('resize', () => this.sortCellsInColumns());
    }

    sortCellsInColumns() {
        if (this.columnAmount !== this.calculateColumnAmount()) {
            this.columnAmount = this.calculateColumnAmount()

            this.sort(this.columnAmount)
        }
    }

    sort(columnAmount) {
        this.removeCellsFromColumns()
        this.sortCells()
        this.placeCellsInColumns(columnAmount)
    }

    calculateColumnAmount() {
        if (window.innerWidth <= this.mdBreakpoint) {
            return this.smColumns
        } else if (window.innerWidth > this.mdBreakpoint && window.innerWidth <= this.lgBreakpoint) {
            return this.mdColumns
        } else if (window.innerWidth > this.lgBreakpoint && window.innerWidth <= this.xlBreakpoint) {
            return this.lgColumns
        } else if (window.innerWidth > this.xlBreakpoint) {
            return this.xlColumns
        }
    }

    removeCellsFromColumns() {
        for (let column of this.columns) {
            for (let child of column.querySelectorAll('.masonry-cell')) {
                this.cells.push(child)
                column.removeChild(child)
            }
        }
    }

    sortCells() {
        this.cells = this.cells.sort(function (a, b) {
            return parseInt(a.getAttribute('data-index')) - parseInt(b.getAttribute('data-index'))
        })
    }

    placeCellsInColumns(columnAmount) {
        let columns = Array.from(this.columns)
        columns = columns.slice(0, columnAmount)
        let index = 0
        for (let cell of this.cells) {
            let arrayIndex = index % (columnAmount)
            columns[arrayIndex].appendChild(cell)
            index++
        }
        this.cells = []
    }
}